var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgUsers = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.128,
    height: 21.128,
    viewBox: "0 0 17.128 21.128",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M632.991,686.043h-.952V683.93h-1.9v2.113h-7.612V683.93h-1.9v2.113h-.952a2.016,2.016,0,0,0-1.9,2.113v14.79a2.016,2.016,0,0,0,1.9,2.113h13.322a2.016,2.016,0,0,0,1.9-2.113v-14.79A2.016,2.016,0,0,0,632.991,686.043Zm-6.661,3.169a3.187,3.187,0,1,1-2.855,3.169A3.027,3.027,0,0,1,626.33,689.212Zm5.709,12.677H620.621v-1.056c0-2.113,3.806-3.275,5.709-3.275s5.709,1.162,5.709,3.275Z",
    transform: "translate(-617.766 -683.93)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUsers, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/users.8ee78036.svg";
export { ForwardRef as ReactComponent };